document.addEventListener("DOMContentLoaded", () => {
  // Select all swiper containers inside .image-carousel
  const carousels = document.querySelectorAll(".image-only-carousel .swiper");

  carousels.forEach((carousel, index) => {
    // Initialize a new Swiper instance for each container
    new Swiper(carousel, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: carousel.querySelector(".swiper-button-next"),
        prevEl: carousel.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: carousel.querySelector(".swiper-pagination"),
        clickable: true,
      },
      // Optional autoplay
      //autoplay: {
        //delay: 5000,
        //disableOnInteraction: false,
      //},
      autoplay: false, // Disable autoplay by default
      // Responsive breakpoints example
      /*breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },*/
    });
  });
});
